class Range
    constructor: (el) ->
        @.$el = el
        @.$hint = undefined
        @.$labels = @.$el.querySelectorAll '.range__label'
        @.$labelsContainer = @.$el.querySelector '.range__labels'
        @.$range = @.$el.querySelector 'input[type="range"]'

        @.unit = @.$el.dataset?.unit ? false
        @.value = @.$range.value

        @.max = if @.$range.max == "" then (@.value * 2) else @.$range.max
        @.min = if @.$range.min == "" then 0 else @.$range.min
        @.showHint = @.$el.classList.contains 'range--show-hint'
        @.step = if @.$range.step == "" then 1 else @.$range.step

        @.CreateHint()
        @.CreateLabels() 
        @.InitEvents()
        @.UpdateRangeBackground()
        @.$el.classList.add 'range--bound'
        return

    CheckLabelsHeight: ->
        self = @
        if @.$labelsContainer
            maxHeight = 0
            @.$labels.forEach (label) ->
                labelBcr = label.getBoundingClientRect()
                if labelBcr.height > maxHeight
                    maxHeight = labelBcr.height
            @.$labelsContainer.style.height = maxHeight + 'px'
            labelsContainerBcr = self.$labelsContainer.getBoundingClientRect()
            @.$labels.forEach (label) ->
                
                if label.dataset?.value
                    labelBcr = label.getBoundingClientRect()
                    labelPositionLeft = (parseFloat(label.style.left) / 100) * labelsContainerBcr.width
                    if (labelPositionLeft - labelBcr.width * .5) < 0
                        label.style.marginLeft = ((labelBcr.width * .5) - labelPositionLeft) + "px"
                    if (labelPositionLeft + labelBcr.width * .5) > labelsContainerBcr.width
                        label.style.marginLeft = (labelsContainerBcr.width - (labelPositionLeft + labelBcr.width * .5)) + "px"
                return
        return
    
    CreateHint: ->
        if @.showHint
            @.$hint = document.createElement 'div'
            @.$hint.classList.add 'range__hint'
            @.$hint.innerHTML = "<span class='range__hint__value'>#{ @.value }</span>" + (if @.unit then "<span class='range__hint__unit'>#{ @.unit }</span>" else "")
            @.$el.appendChild @.$hint
            @.UpdateHint()
        return
    
    CreateLabels: ->
        self = @
        if @.$labels.length > 0
            labelsWidth = ((1 / @.$labels.length) * 100) + "%"
        @.$labels.forEach (label) ->
            if label.dataset?.value
                labelValue = parseFloat label.dataset.value
                value = if labelValue >= self.min && labelValue <= self.max then labelValue else null
                if value != null
                    positionLeft = (((self.max - self.min) - (self.max - value)) / (self.max - self.min)) * 100
                    label.style.left = positionLeft + "%"
                    label.style.maxWidth = labelsWidth
                    label.style.width = labelsWidth
                else
                    label.remove()
            return
        if @.$labels.length > 0
            @.CheckLabelsHeight()
        return

    InitEvents: ->
        self = @
        @.$range.addEventListener 'input', (e) ->
            self.value = self.$range.value
            self.UpdateRangeBackground()
            self.$el.dispatchEvent new CustomEvent 'range-value-changed', {
                bubbles: false
                detail: {
                    value: self.value
                }
            }
            if self.showHint
                self.UpdateHint()
            return
        @.$el.addEventListener 'range-set-max', (e) ->
            max = e.detail?.max ? false
            if max
                self.SetMax max
            return
        @.$el.addEventListener 'range-set-min', (e) ->
            min = e.detail?.min ? false
            if min
                self.SetMin min
            return
        @.$el.addEventListener 'range-set-value', (e) ->
            triggerEvents = e.detail?.triggerEvents ? true
            value = e.detail?.value ? false
            if typeof value == 'number'
                self.SetValue value, triggerEvents
            return
        @.$el.addEventListener 'range-update-background', (e) ->
            self.UpdateRangeBackground()
            return
        @.$el.addEventListener 'range-check-labels-height', (e) ->
            self.CheckLabelsHeight()
            return
        @.$el.addEventListener 'touchstart', (e) ->
            self.$el.classList.add 'range--touch-hint-shown'
            return
        @.$el.addEventListener 'touchleave', (e) ->
            self.$el.classList.remove 'range--touch-hint-shown'
            return
        @.$el.addEventListener 'touchend', (e) ->
            self.$el.classList.remove 'range--touch-hint-shown'
            return

    SetMax: (max) ->
        if !isNaN(max)
            @.$range.max = max
            @.max = max
        return
    
    SetMin: (min) ->
        if !isNaN(min)
            @.$range.min = min
            @.min = min
        return

    SetValue: (value, triggerEvents) ->
        triggerEvents = if typeof triggerEvents == 'null' || typeof triggerEvents == 'undefined' then true else triggerEvents
        if !isNaN(value)
            if value >= @.min && value <= @.max
                @.$range.value = value
                @.value = value
                @.UpdateRangeBackground()
                @.UpdateHint()
                if triggerEvents
                    @.$range.dispatchEvent new Event 'change', { bubbles: true }
                    @.$range.dispatchEvent new Event 'input', { bubbles: true }
        return
    
    UpdateHint: ->
        if @.showHint
            thumbHalfWidth = 10
            thumbPos = (((@.value - @.min) / (@.max - @.min)) * ((@.$range.offsetWidth - thumbHalfWidth) - thumbHalfWidth)) + thumbHalfWidth
            if @.$hint
                @.$hint.querySelector '.range__hint__value'
                    .innerText = @.value
                @.$hint.style.left = thumbPos + 'px'
        return
    
    UpdateRangeBackground: ->
        bgrdWidth = (((@.max - @.min) - (@.max - @.value)) / (@.max - @.min)) * @.$range.offsetWidth
        @.$range.style.boxShadow = "inset #{bgrdWidth}px 0 var(--color-red-dark)"
        return
    

BindRanges = ->
    document.querySelectorAll '.range:not(.range--bound)'
        .forEach (el) ->
            new Range el
            return
    return

RangesResizeBinder = ->
    if document.querySelectorAll('.range--bound').length > 0
        window.addEventListener 'resize', (e) ->
            window.clearInterval(window["range-resize"])
            window["range-resize"] = window.setInterval ->
                window.clearInterval(window["range-resize"])
                document.querySelectorAll '.range--bound'
                    .forEach (rangeEl) ->
                        rangeEl.dispatchEvent new CustomEvent 'range-update-background', { bubbles: false }
                        rangeEl.dispatchEvent new CustomEvent 'range-check-labels-height', { bubbles: false }
                        return
                return
            , 300
            return

RangesResizeBinder()

RangesBindComponents = ->
    BindRanges()
    RangesResizeBinder()
    return

window.addEventListener 'bind-components', RangesBindComponents

class RangeCreate
    constructor: (options) ->
        @.$el = null

        @.options = options ? {}

        @.CreateElement()
        if !@.options?.bindLater
            new Range @.$el
        return @.$el

    CreateElement: ->
        self = @
        @.$el = document.createElement (@.options.tag ? 'div')
        @.$el.classList.add 'range'
        if @.options.showHint
            @.$el.classList.add 'range--show-hint'
        if @.options.unit
            @.$el.dataset.unit = @.options.unit
        if @.options.attrs
            @.$el = window.appUtils.Attributes @.options.attrs, @.$el
        @.$el.innerHTML = "
            <input type='range'#{ if @.options.disabled then " disabled" else "" }#{ if @.options.max then " max='#{ @.options.max }'" else "" }#{ if @.options.min then " min='#{ @.options.min }'" else "" }#{ if @.options.name then " name='#{ @.options.name }'" else "" }#{ if @.options.step then " step='#{ @.options.step }'" else "" }#{ if @.options.value then " value='#{ @.options.value }'" else "" } />
        "
        if @.options.labels
            if @.options.labels.length > 0
                labelsEl = document.createElement 'div'
                labelsEl.classList.add 'range__labels'
                @.options.labels.forEach (label) ->
                    labelEl = document.createElement 'div'
                    labelEl.classList.add 'range__label'
                    if label.value
                        labelEl.dataset.value = label.value
                    labelEl.innerHTML = "
                        #{ label.text ? "" }
                    "
                    labelsEl.appendChild labelEl
                    return
                @.$el.appendChild labelsEl
        return

window.CreateRange = (options) ->
    return new RangeCreate options